import styled from "styled-components";
import { TrashIconWrapper } from "../../../../../components/CaptionBlock/styles";
import { GrayColors } from "@smartsuite/types";

interface IIntegrationLabel {
  fontSize: string;
  color: string;
  paddingLeft: string;
  textAlign: "left" | "center" | "right";
}

export const StyledAddButtonWrapper = styled.div`
  margin-bottom: 12px;
`;

export const StyledGroupWrapper = styled.div``;

export const StyledGroupTitleWrapper = styled.div`
  cursor: default;
  user-select: none;

  &.collapsible {
    cursor: pointer;
    display: flex;

    & > .icon {
      margin: 7px 6px 0 -18px;

      &.collapsed {
        transform: rotate(270deg);
      }
    }
  }
`;

export const StyledGroupTitle = styled.div`
  padding-bottom: 13px;
`;

export const StyledContainerWrapper = styled.div`
  .picker-input-field__placeholder {
    margin-left: 14px;
  }
  .is-clear {
    background-color: ${GrayColors["G-0-5"]};
    .picker-input-field__placeholder {
      color: ${GrayColors["G-4"]};
    }
  }
  .pill-picker-editor {
    display: flex;
  }
  &:hover {
    ${TrashIconWrapper} {
      visibility: visible;
    }
  }
  width: 100%;

  .disable-references {
    .pill-picker-editor__plus-button {
      display: none;
    }
  }
`;

export const StyledContainerWrapperNoPills = styled.div`
  &:hover {
    ${TrashIconWrapper} {
      visibility: visible;
    }
  }
  margin-bottom: 10px;
  width: 100%;

  div.field-type-pill {
    background: white;
    border-color: white;
    padding-left: 5px;

    &:hover,
    &:not(.is-disabled):not(.is-error):not(.is-removable):hover {
      border-color: transparent;
    }

    .text {
      font-size: 13px;
      line-height: 18px;
    }
  }
`;

export const IntegrationLabelStyled = styled.span<Partial<IIntegrationLabel>>`
  width: 100%;
  padding-left: ${({ paddingLeft }) => paddingLeft};
  text-align: ${({ textAlign }) => textAlign};
  color: ${({ color }) => color};
`;

IntegrationLabelStyled.defaultProps = {
  paddingLeft: "10px",
  textAlign: "left",
  color: GrayColors["G-8"],
  fontSize: ".9em",
};

export const StyledTooltipWrapper = styled.div`
  display: inline-flex;
  margin-top: -2px;
  margin-left: 5px;

  vertical-align: middle;
`;
